module.exports = function () {
  var $ = require('boxjs/dist/utils/_bdboxWrapper');
  /* eslint-disable */

  /**
   * 获取框的版本号
   * @memberOf Bdbox.utils
   * @name getVersion
   * @function
   * @return {String} version 返回框的版本号
   * @author wangyongqing01
   * @version  $Id: getVersion.js 175996 2014-05-16 00:48:03Z wangyongqing01 $
   */


  var self = function () {
    var back = 0;

    if (window.baiduboxapp_version) {
      back = window.baiduboxapp_version;
    } else if ($.$isBox()) {
      var str = navigator.userAgent;
      var a;

      if (a = /([\d+.]+)_(?:diordna|enohpi)_/.exec(str)) {
        a = a[1].split('.');
        back = a.reverse().join('.');
      } else if (a = /baiduboxapp\/([\d+.]+)/.exec(str)) {
        back = a[1];
      }
    }

    self = function () {
      return back;
    };

    return back;
  };

  return self;
}();